import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import P from '../P';
import { NotificationWrapper, IconWrapper, MessageWrapper, CloseIconWrapper, StyledModal } from './styles';

const NotificationModal = ({
  isOpen,
  onClose,
  campaignId,
  title = "Notificaciones", 
  messageText 
}) => {
  const defaultMessage = campaignId ? (
    <>
      La imagen de tu mensaje <strong>{campaignId}</strong> no cumple los parámetros establecidos. Cargue de nuevo.
    </>
  ) : (
    'La imagen no cumple los parámetros establecidos. Cargue de nuevo.'
  );

  return (
    <StyledModal
      open={isOpen}
      onClose={onClose}
      width="450px" 
      height="auto"
    >
      <P font="20px/26px 'DMSans-Medium'" textAlign="left" p="20px 20px 10px 20px" color="#4F5356">
        {title}
      </P>
      <NotificationWrapper>
        <IconWrapper>
          <Icon icon="clockcount" width={24} height={24} color="#466268" /> 
        </IconWrapper>
        <MessageWrapper>
          <P  color="#466268" textAlign="justify" font="14px/20px 'DMSans-Medium'">
            {messageText || defaultMessage}
          </P>
        </MessageWrapper>
        <CloseIconWrapper onClick={onClose}>
          <Icon icon="trash" width={18} height={18} color="#8f8f8f" /> 
        </CloseIconWrapper>
      </NotificationWrapper>
    </StyledModal>
  );
};

NotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  campaignId: PropTypes.string,
  title: PropTypes.string,
  messageText: PropTypes.string,
};

export default NotificationModal; 